import { useMediaQuery } from "@mui/material";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";

export const AppLayout = ({
  TopNavigation,
  SideNavigation,
  PageContent,
}: {
  TopNavigation: React.ReactNode;
  SideNavigation: React.ReactNode | null;
  PageContent: React.ReactNode;
}) => {
  const smallScreen = useMediaQuery("(max-width: 465px)");

  return (
    <Layout
      style={{
        minHeight: "100vh",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      <div style={{ flexShrink: 0 }}>{TopNavigation}</div>
      <Layout
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "row",
          overflow: "hidden",
          backgroundColor: "#f5f5f5",
        }}
        hasSider={SideNavigation != null}
      >
        {SideNavigation}
        <Content
          style={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            padding: smallScreen ? "0.5rem" : "2rem",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {PageContent}
        </Content>
      </Layout>
    </Layout>
  );
};
